import WebpageSection from "../components/WebpageSection";

export default function AboutUs() {
  return (
    <div>
      <WebpageSection />
    </div>
  );
}
